import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";
import type { HelperSettings } from "./types";

const KEY = ["dev", "browser-helpers"] as const;

/** Lista stanowisk odświeża się sama — wtyczka melduje się co ~5 minut, więc bez tego
 *  panel pokazywałby stan sprzed wejścia na stronę. */
export function useHelperOverview() {
  return useQuery({
    queryKey: KEY,
    queryFn: api.getHelperOverview,
    refetchInterval: 30_000,
  });
}

export function useHelperLogs(params: { installId?: string; verbose?: boolean; limit?: number }) {
  return useQuery({
    queryKey: [...KEY, "logs", params.installId ?? "", !!params.verbose, params.limit ?? 100],
    queryFn: () => api.getHelperLogs(params),
    refetchInterval: 30_000,
  });
}

export function useHelperMutations() {
  const qc = useQueryClient();
  const inv = () => qc.invalidateQueries({ queryKey: KEY });
  return {
    update: useMutation({
      mutationFn: (v: {
        id: string;
        label?: string;
        log_verbose?: boolean;
        desired?: Partial<HelperSettings>;
      }) => api.updateHelperInstance(v.id, v),
      onSuccess: inv,
    }),
    remove: useMutation({
      mutationFn: (id: string) => api.deleteHelperInstance(id),
      onSuccess: inv,
    }),
  };
}
